import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./skillupgrade.css";

const SkillUpgrade = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Programs",
      description: "Check out short-term programs like 1-Week & 1-Month bootcamps.",
      icon: "📘",
      link: "/skillupgrade/programs",
    },
    {
      title: "Internships",
      description: "Gain real-world experience through internship opportunities.",
      icon: "💼",
      link: "/skillupgrade/internships",
    },
    {
      title: "Courses",
      description: "Explore full-stack, AI/ML, Data Science, and more to upgrade your skills.",
      icon: "💻",
      link: "/skillupgrade/courses",
    },
  ];

  return (
    <div className="skillupgrade-container">
      <h1 className="skillupgrade-title">🚀 Skill Upgrade</h1>

      <div className="skillupgrade-sections">
        {cards.map((card, index) => (
          <motion.div
            key={index}
            className="section-card"
            whileHover={window.innerWidth > 768 ? { scale: 1.05, rotate: 1 } : {}}
            whileTap={{ scale: 0.95 }}
            onClick={() => navigate(card.link)}
          >
            <div className="icon"><span>{card.icon}</span></div>
            <h2>{card.title}</h2>
            <p>{card.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SkillUpgrade;
